<template>
  <div v-if="visible" class="error">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'ErrorView',

  data() {
    return {
      visible: false,
      message: '',
      lastErrorCode: null,
      errors: {
        UNKNOWN_ERROR: 'File tidak ditemukan. File mungkin telah dihapus atau URL yang Anda masukkan salah.',
        NOT_FOUND: 'File tidak ditemukan. File mungkin telah dihapus atau URL yang Anda masukkan salah.',
        NOT_VALID: 'File tidak ditemukan. File mungkin telah dihapus atau URL yang Anda masukkan salah.',
        NOT_SUPPORTED: 'Maaf, situs ini tidak didukung.',
        API_ERROR: 'File tidak ditemukan. File mungkin telah dihapus atau URL yang Anda masukkan salah.',
        NETWORK_ERROR: 'Terjadi kesalahan jaringan. Silakan periksa koneksi internet Anda dan coba lagi.',
        TIMEOUT: 'Permintaan memakan waktu terlalu lama. Silakan coba lagi.',
        RATE_LIMIT: 'Terlalu banyak permintaan. Silakan tunggu sebentar dan coba lagi.',
        PRIVATE_PAGE: 'Konten ini bersifat pribadi dan tidak dapat diakses.'
      }
    }
  },

  methods: {
    extractRaw(input) {
      if (!input) return 'UNKNOWN_ERROR'
      if (typeof input === 'string') return input

      // axios error
      const axiosMsg =
        input?.response?.data?.message ||
        input?.response?.data?.error ||
        input?.message

      if (axiosMsg) return String(axiosMsg)

      try {
        return JSON.stringify(input)
      } catch {
        return 'UNKNOWN_ERROR'
      }
    },

    normalizeCode(raw) {
      const s = String(raw || 'UNKNOWN_ERROR').trim()

      // whitelist
      const allowed = new Set([
        'UNKNOWN_ERROR',
        'NOT_VALID',
        'NETWORK_ERROR',
        'TIMEOUT',
        'RATE_LIMIT',
      ])
      if (allowed.has(s)) return s

      const low = s.toLowerCase()

      // частые случаи
      if (low.includes('not_valid') || low.includes('not valid') || low.includes('invalid url')) {
        return 'NOT_VALID'
      }

      // axios/network
      if (low.includes('network error') || low.includes('failed to fetch')) {
        return 'NETWORK_ERROR'
      }

      // таймауты
      if (low.includes('timeout') || low.includes('timed out') || low.includes('ecconnaborted')) {
        return 'TIMEOUT'
      }

      if (low.includes('private')) {
        return "PRIVATE_PAGE"
      }

      if (low.includes('not found')) {
        return "NOT_FOUND"
      }

      if (low.includes('not supported')) {
        return "NOT_SUPPORTED"
      }

      // rate limit
      if (low.includes('too many requests') || low.includes('rate limit') || low.includes('429')) {
        return 'RATE_LIMIT'
      }

      // API-ошибки
      if (low.includes('api_error') || low.includes('api error') || low.includes('server error')) {
        return 'API_ERROR'
      }

      return 'UNKNOWN_ERROR'
    },

    show(input) {
      const raw = this.extractRaw(input)
      const code = this.normalizeCode(raw)

      this.lastErrorCode = code
      this.message = this.errors[code] || this.errors.UNKNOWN_ERROR
      this.visible = true

      // В аналитику — только нормализованный код
      this.$root.$emit('show-error', code)

      // В dev можно вывести детали
      if (typeof process !== 'undefined' && process?.env?.NODE_ENV !== 'production') {
        console.debug('[ErrorView]', {raw, code, input})
      }
    },

    hide() {
      this.visible = false
      this.message = ''
      this.lastErrorCode = null
    }
  }
}
</script>

<style>
.error {
  border: 1px solid #dadada;
  clear: both;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 28px;
  width: 698px;
  box-shadow: 0 1px 0 0 #e9e9e9;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px;
}
</style>
